import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import App from './app';
import { loadApp } from 'data/app/app-actions';
import { makeSelectIsApp } from 'data/config/runtime-config-selectors';

export const mapStateToProps = createStructuredSelector({
    isApp: makeSelectIsApp(),
});

export const mapDispatchToProps = (dispatch) => ({
    loadApp: () => dispatch(loadApp()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
